// ErrorBoundary.tsx
import React, { Component, ReactNode } from "react";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || <DefaultErrorFallback />;
    }

    return this.props.children;
  }
}

// Default error fallback component
const DefaultErrorFallback = () => (
  <div className="flex items-center justify-center p-8 bg-transparent rounded-lg">
    <div className="text-center">
      <h3 className="text-lg font-semibold text-gray-700 mb-2">
        Something went wrong
      </h3>
      <p className="text-gray-800">Unable to load Content</p>
    </div>
  </div>
);

export default ErrorBoundary;
